export default "__VITE_ASSET__C04Ael1c__"